export default __webpack_public_path__ + "static/media/1.5eb4e7e5.jpg";